// localStorage key for the persisted store (the `persist` middleware's `name`). CGTrader
// has no SPA shell - every navigation is a full-page load - so persisting lets generation
// status survive navigation and propagate across tabs (see index.js).
export const STORAGE_KEY = 'cgt:generationStatus'

// The single resolved status a consumer (sidebar today, top nav later) renders.
export const GENERATION_STATUS = {
  IDLE: 'idle',
  GENERATING: 'generating',
  ENHANCING: 'enhancing',
  SUCCEEDED: 'succeeded',
  FAILED: 'failed',
}

export const DEFAULT_GENERATION_STATUS = {
  // Live status of the in-flight run.
  isGenerating: false,
  isEnhancing: false,
  enhancingSessionId: undefined,
  runId: undefined,
  sessionId: undefined,
  generationStartedAt: null,
  // Owner of the persisted status: the id (normalized to a string, see resolveViewerId)
  // of the user who started the run. localStorage is shared by every user of a browser,
  // so the site-wide nav gates on this to avoid surfacing one user's run to a later
  // anon/other account (see GenerationStatus/actions).
  userId: null,
  // Outcome of the most recently finished run (generated or failed). Shape:
  // { status: 'succeeded'|'failed', runId, sessionId, providerModelId, isEnhancement,
  //   finishedAt, ...(success: slug, title, previewUrl, pathname)
  //              ...(failure: failureReason, failureMessage, providerErrorCode) }
  lastResult: null,
}
